import { render } from "./ModalImages.vue?vue&type=template&id=74209670&scoped=true&ts=true"
import script from "./ModalImages.vue?vue&type=script&lang=ts"
export * from "./ModalImages.vue?vue&type=script&lang=ts"

import "./ModalImages.vue?vue&type=style&index=0&id=74209670&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74209670"]])

export default __exports__